export enum Vertical {
  General = 'general',
  Fashion = 'fashion',
  HomeDecor = 'hd',
  Jewelry = 'jewelry',
  DIY = 'diy',
}
